export default __webpack_public_path__ + "static/media/guide-coaching-à-distance.4355966e.jpg";